export default {
    getStoredArticleById: (state) => (id) => {
        const article = state.articles.find(article => article.id === id)
        if (article === undefined) {
            state.articles.push({ id: id })
            return state.articles.find(article => article.id === id)
        } else {
            return article
        }
    },
    getStoredArticlesByPage: (state) => (page = 1) => {
        if (isNaN(page)) {
            page = 1
        }
        return state.articles.filter(article => article.page === page)
    },
    getArticlePages: state => {
        return state.article_pages
    },
    getNewArticle: (state) => {
        return state.newArticle
    },
}
